import { render, staticRenderFns } from "./overhaul.vue?vue&type=template&id=4ff17c24&"
import script from "./overhaul.vue?vue&type=script&lang=js&"
export * from "./overhaul.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports